import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconTest2 = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.52374 3.06975C10.0893 3.06975 10.5477 2.61129 10.5477 2.04576C10.5477 1.48023 10.0893 1.02177 9.52374 1.02177C8.95821 1.02177 8.49976 1.48023 8.49976 2.04576C8.49976 2.61129 8.95821 3.06975 9.52374 3.06975Z" fill={color}/>
<path d="M11.572 1.63863C12.0245 1.63863 12.3913 1.27181 12.3913 0.819315C12.3913 0.36682 12.0245 0 11.572 0C11.1195 0 10.7527 0.36682 10.7527 0.819315C10.7527 1.27181 11.1195 1.63863 11.572 1.63863Z" fill={color}/>
<path d="M15.0132 13.9784L10.7528 7.16632V5.12056H11.9818V3.68692H5.01791V5.12056H6.24688V7.16632L1.98651 13.9784C1.83031 14.268 1.74097 14.5991 1.74097 14.9517C1.74097 16.0828 2.65786 17 3.78925 17H13.2107C14.3418 17 15.259 16.0831 15.259 14.9517C15.259 14.5991 15.1697 14.268 15.0132 13.9784ZM5.24793 11.4672L7.68053 7.57756V5.12025H9.31916V7.57756L11.7518 11.4672H5.24793Z"  fill={color}/>
</svg>

    </div>
);

export default IconTest2;
